export { MiniCart } from "./mini-cart.component";
